import { createFlags } from 'flag';
import {
  customer,
  editor,
  writer,
  admin,
  developmentalEditor,
  contentTeam,
  proProofreader,
} from './roles';

const isFlaggingEnabled = process.env.APP_MODE !== 'development';

export const releaseFlags = {
  isFlaggingEnabled,
  customer,
  editor,
  writer,
  admin,
  developmentalEditor,
  contentTeam,
  proProofreader,
};

const {
  FlagBackendProvider,
  Flag,
  useFlag,
} = createFlags(releaseFlags);

export {
  FlagBackendProvider,
  Flag,
  useFlag,
};
